import { render, staticRenderFns } from "./ClientActions.vue?vue&type=template&id=2e0ff76a&scoped=true&"
import script from "./ClientActions.vue?vue&type=script&lang=js&"
export * from "./ClientActions.vue?vue&type=script&lang=js&"
import style0 from "./ClientActions.vue?vue&type=style&index=0&id=2e0ff76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0ff76a",
  null
  
)

export default component.exports